<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  message?: string[] | string | null
  flashy?: boolean
  innerClass?: string
}>()

const messageParsed = computed(() => {
  const message = props.message
  switch (true) {
    case message === null || message === undefined:
      return null

    case typeof message === 'string':
      return message

    default:
      return message[0]
  }
})
</script>
<template>
  <div v-if="message">
    <p
      class="text-sm"
      :class="{
        'text-danger-600 dark:text-danger-500': !flashy,
        'py-2 px-4 bg-danger-100 text-danger-900 dark:bg-danger-700 dark:text-danger-200 rounded-sm':
          flashy,
        [innerClass || 'xxx']: !!innerClass,
      }"
    >
      {{ messageParsed }}
    </p>
  </div>
</template>
